import { NgModule } from '@angular/core'

import { RouterModule,
         Routes } from '@angular/router'

import { AppContainerComponent, 
         PathNotFoundComponent } from './_shared/index'


// CORE
import { TermsPageComponent } from './terms-page/terms-page.component'
import { PrivacyPageComponent } from './privacy-page/privacy-page.component'
// import { ThankYouPageComponent } from './thank-you-page/thank-you-page.component'
// import { ContactPageComponent } from './contact-page/contact-page.component'


// CUSTOM: LCP
import { AboutComponent } from './about/about.component'
import { ContactComponent } from './contact/contact.component'
import { ProjectComponent } from './project/project.component'
import { ProjectsComponent } from './projects/projects.component'
import { TeamComponent } from './team/team.component'
import { HomepageComponent } from './homepage/homepage.component'

// import { DeleteOrderPopupComponent } from  './delete-order-popup/delete-order-popup.component'
// import { DeleteServicePopupComponent } from './delete-service-popup/delete-service-popup.component'


// CUSTOM: OAK PARK
// import { HomeComponent } from './home/home.component'
// import { RequestQuotePageComponent } from './request-quote-page/request-quote-page.component'
// import { PaymentSubmittedPageComponent } from './payment-submitted-page/payment-submitted-page.component'
// import { OrderSubmittedPageComponent } from './order-submitted-page/order-submitted-page.component'
// import { OrderInvoicePageComponent } from './order-invoice-page/order-invoice-page.component'
// import { ConfirmOrderPopupComponent } from './confirm-order-popup/confirm-order-popup.component'

import { CollectionsComponent } from './collections/collections.component'
import { CollectionLogosComponent } from './collection-logos/collection-logos.component'
import { CollectionDefaultComponent } from './collection-default/collection-default.component'

import { ServicesComponent } from './services/services.component'
import { ServiceComponent } from './service/service.component'
// import { ServiceV2Component } from './service-v2/service-v2.component'







// private and demo pages (login, cookies, repo, popups, home-v1) are lazily loaded, so the public
// pages don't download their code (and the material modules they use)
const ROUTES: Routes = [

  { path: '',
    component: AppContainerComponent,
    // data: { title: 'welcome' },
    children: [


      { path: '', pathMatch: 'full', component: HomepageComponent}, // default title + description from SeoService

      { path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
        data: { title: 'login', noindex: true } 
      },
    
      { path: 'cookies',
        loadComponent: () => import('./auth/cookie-consent-page/cookie-consent-page.component').then(m => m.CookieConsentPageComponent),
        data: { title: 'cookies', noindex: true }
      },
      // { path: 'home', component: HomepageComponent },

      // { path: 'about', component: AboutComponent },
      // { path: 'case-studies', component: CaseStudiesComponent },
      // { path: 'contact', component: ContactComponent },
      // { path: 'projects', component: ProjectsComponent },
      // { path: 'projects/:slug', component: ProjectComponent },

      { path: 'team',
        component: TeamComponent,
        data: { title: 'our team', description: 'meet the lowercase productions team, communicating design with intelligence, style, and joy from San Francisco.' }
      },
      { path: 'about',
        component: AboutComponent,
        data: { title: 'about', description: 'lowercase productions improves visual communications within the built environment. learn about our San Francisco design and communications practice.' }
      },
      { path: 'contact',
        component: ContactComponent,
        data: { title: 'contact', description: 'get in touch with lowercase productions, a San Francisco visual design and communications agency. how may we help?' }
      },
      // { path: 'work', component: ProjectsComponent },
      // { path: 'work/:slug', component: ProjectComponent },

      { path: 'work', 
        children: [
          { path: '',
            component: ProjectsComponent,
            data: { title: 'our work', description: 'projects by lowercase productions: communicating big ideas through branding, signage, print, and digital media.' } 
          },
          { path: ':slug',
            component: ProjectComponent,
          }
        ]
      },


      // { path: '',
      //   component: HomeComponent,
      //   data: { title: 'Welcome' },
      // },


      { path: 'demo/home-v1', data: { noindex: true },
        loadChildren: () => import('./homepage-v1/homepage-v1.module').then(m => m.HomepageV1Module) },


      // { path: 'request-quote',
      //   component: RequestQuotePageComponent,
      //   data: { title: 'Request a Quote' }
      // },

      // { path: 'request-quote/thank-you',
      //   component: ThankYouPageComponent,
      //   data: { title: 'Thank you' }
      // },

      // { path: 'payment-submitted',
      //   component: PaymentSubmittedPageComponent,
      //   data: { title: 'Payment Submitted' }
      // },

      // { path: 'order-submitted',
      //   component: OrderSubmittedPageComponent,
      //   data: { title: 'Order Sbmitted' }
      // },

      // { path: 'terms',
      //   component: TermsPageComponent,
      //   data: { title: 'terms of use', description: 'terms of use for lowercaseproductions.com.' }
      // },

      // { path: 'privacy',
      //   component: PrivacyPageComponent,
      //   data: { title: 'privacy policy', description: 'privacy policy for lowercaseproductions.com.' }
      // },

      // { path: 'orders/:obfuscated_id',
      //   component: OrderInvoicePageComponent,
      //   data: { title: 'Invoice' }
      // },


      { path: 'repo', 
        loadComponent: () => import('./repo/repo.component').then(m => m.RepoComponent),
        data: { title: 'software repository', noindex: true }
      },

      // { path: 'services', 
      //   component: ServicesComponent,
      //   data: { title: 'services' } 
      // },

      { path: 'services', 
        children: [
          { path: '',
            component: ServicesComponent,
            data: { title: 'services: branding, signage, marketing & digital media', description: 'branding, signage, marketing & outreach, and digital media services from lowercase productions, improving visual communications within the built environment.' } 
          },
          { path: ':slug',
            component: ServiceComponent,
          }
        ]
      },

      { path: 'collections', 
        children: [
          { path: '',
            component: CollectionsComponent,
            data: { title: 'collections', description: 'exploring patterns and themes within the practice of lowercase productions, a San Francisco visual design and communications agency.' } 
          },
          { path: 'logos',
            component: CollectionLogosComponent,
            data: { title: 'logos | collections', description: 'our logos over the years: logo and identity design by lowercase productions.',
                    breadcrumbs: [['collections', '/collections'], ['our logos over the years', '/collections/logos']] }
          },
          { path: ':slug',
            component: CollectionDefaultComponent,
          }
        ]
      },

    ]
  },


  { path: 'demo/degenkolb-2022',
    data: { noindex: true },
    loadChildren : () => import('./book/book.module').then(m => m.BookModule)},


  { path: 'admin',
    data: { noindex: true },
    loadChildren: () => import(`./admin/admin.module`).then(m => m.AdminModule)
  },

  // { path: 'login',
  //   component: LoginComponent,
  //   data: { title: 'login' } 
  // },

  // { path: 'cookies',
  //   component: CookieConsentPageComponent,
  //   data: { title: 'cookies' }
  // },


    // POPUPS
  
    { outlet: 'p',
      path: 'login',
      loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
      data: { title: 'login' }
    },

    // { outlet: 'p',
    //   path: 'confirm',
    //   component: ConfirmOrderPopupComponent,
    //   data: { title: 'Confirm Order' }
    // },

    { outlet: 'p',
      path: 'cookies',
      loadComponent: () => import('./auth/cookie-consent-popup/cookie-consent-popup.component').then(m => m.CookieConsentPopupComponent),
      data: { title: 'Cookies' }
    },

    // { outlet: 'p',
    //   path: 'delete-order',
    //   component: DeleteOrderPopupComponent,
    //   data: { title: 'Delete Order' }
    // },

    // { outlet: 'p',
    //   path: 'delete-service',
    //   component: DeleteServicePopupComponent,
    //   data: { title: 'Delete Order' }
    // },

    { outlet: 'p',
      path: 'delete-user',
      loadComponent: () => import('./delete-user-popup/delete-user-popup.component').then(m => m.DeleteUserPopupComponent),
      data: { title: 'Delete User' }
    },


  { path: '**',
    component: PathNotFoundComponent,
    data: { title: 'page not found', noindex: true }
  },
  

]

@NgModule({
  // imports: [ RouterModule.forRoot(ROUTES, { enableTracing: !environment.production }) ],
  imports: [ RouterModule.forRoot(ROUTES, { 
    anchorScrolling: 'enabled',
    // scrollPositionRestoration: 'enabled',
    scrollPositionRestoration: 'disabled' ,
  }) ],
  // , { scrollPositionRestoration: 'enabled' }
  // imports: [ RouterModule.forRoot(ROUTES) ],

  exports: [ RouterModule ]
})

export class AppRoutingModule {}
